import React from 'react';

import classes from './DashedBorder.module.scss';
import { ReactComponent as Border } from '../../../assets/image/dashed-border.svg';

type DashedBorderProps = {
  color?: string;
};

const DashedBorder = ({ color = 'primary-700' }: DashedBorderProps) => {
  return (
    <div style={{ color: `var(--${color})` }}>
      <Border className={classes.border} />
    </div>
  );
};

export { DashedBorder };
